module.exports = __webpack_public_path__ + "img/faq-dropdown.ef431d1c.svg";